<div class="description-container">
    <div *ngIf="product.images" class="image">
        <img src="" alt="">
    </div>
    <div class="text">
        <p class="title">{{ product.name }}</p>
        <p class="description"
            innerHTML="{{ product.description }}"></p>
    </div>
</div>